import React from "react";
import styles from "./InfiniteEndMessage.module.scss";
import Barrier from "components/SVGComponents/Barrier";

const InfiniteEndMessage = ({ message }) => {
  return (
    <div className={styles.InfiniteEndMessage}>
      <div className={styles.seperator} />
      <div className={styles.infinite_text}>
        {/* <Barrier /> */}
        <p>{message}</p>
      </div>
      <div className={styles.seperator} />
    </div>
  );
};

export default InfiniteEndMessage;
